import axios from '@services/api/axios';

interface IFile {
  id: number | undefined;
  recruiting_id: number | undefined;
  fileName: string | undefined;
}

const api = {
  getOptionValues: (companyId: number) =>
    axios.post('/recruiting-request', { company_id: companyId }),
  getFilterSettings: () => axios.get('/recruiting/filter/setting'),
  getMyApplicationData: () => axios.get('/recruiting'),
  getFilteredApplications: (status: string, postName: string, startDate: string, endDate: string, department: string, responsibleRecruiter: string, chief: string) => 
    axios.get(`/recruiting?application_status=${status}&name_of_post_id=${postName}&start_date=${startDate}&end_date=${endDate}&department_to=${department}&responsible_recruiter=${responsibleRecruiter}&chief_id=${chief}`),
  getExport: (status: string, postName: string, startDate: string, endDate: string, department: string, responsibleRecruiter: string, chief: string) => 
    axios.get(`/recruiting-export?application_status=${status}&name_of_post_id=${postName}&start_date=${startDate}&end_date=${endDate}&department_to=${department}&responsible_recruiter=${responsibleRecruiter}&chief_id=${chief}`, { responseType: 'blob' }),
  getApplicationById: (id: number) => axios.get(`/recruiting/${id}`),
  updateApplicationById: (id: string, data: {application_status: number}) => axios.put(`/recruiting/update/${id}`, data),
  getDutyCandidatesById: (namePostId: number) => axios.get(`/recruiting/candidate/duty/${namePostId}`),
  deleteCandidate: (id: number) => axios.delete(`/recruiting-candidate/${id}`),
  getInterviewCandidate: () => axios.get('/recruiting-candidate'),
  getCandidateById: (id: string) => axios.get(`/recruiting-candidate/${id}`),
  getResult: () => axios.post('/recruiting-result'),
  getFile: (data: IFile) =>
    axios.post('/download/resume', data, { responseType: 'blob' }),

  getResultFile: () =>
    axios.post('/download/recruiting', {}, { responseType: 'blob' }),

  saveNewApplication: (data: any) => axios.post('/recruiting', data),
  saveApplicationCandidate: (data: any) =>
    axios.post('recruiting-candidate/save', data),

  updApplication: (id: string | undefined, data: any) =>
    axios.put(`/recruiting/${id}`, data),
  updCandidate: (id: string | undefined, data: any) =>
    axios.put(`/recruiting-candidate/save/${id}`, data),
  updCanditeFile: (data: any) =>
    axios.post('/recruiting-candidate/update-file', data),
  postData: (data) => axios.post('/ideaOffer', data),
};

export default api;
